/* carousel-wheel-swipe.js
   Wheel-/Trackpad-/Magic-Mouse-Wischgesten für Flickity-Karussells — plus
   Autoplay-Neustart nach manueller Interaktion.

   Betrifft ZWEI Flickity-Bereiche (die nativen slider-element/.card-grid-Karussells
   brauchen das NICHT — die sind via overflow-Regel in theme.css wischbar):

   1) "Ergänzende Produkte" / "Passt gut dazu" (<product-complementary class="… flickity">)
   2) Die Bild-Slideshow(s) (<slideshow-element>), z.B. unten auf der Startseite.
   3) Lookbook-Produktkarussell (<carousel-element>), z.B. "Aus der gleichen Serie"
      auf den Tahoe-Produktseiten (Hotspot-Bild + Produkt-Karussell mit Dots).

   Was das Script macht:
   • Horizontale Wisch-/Wheel-Geste  ->  flickity.next()/previous()
     (vertikales Seiten-Scrollen wird NICHT gekapert — nur horizontal-dominante Gesten).
   • Bei Slideshows mit autoplay: nach JEDER Interaktion (Wisch, Drag, Klick) wird der
     Autoplay wieder gestartet. Flickity stoppt den Player beim manuellen Ziehen sonst
     DAUERHAFT (player.stop()) und läuft nicht von selbst weiter — genau dieses Verhalten
     wird hier behoben. Buttons + Click-Drag bleiben voll funktionsfähig.

   Nutzt ausschließlich die theme-eigene Flickity-API (playPlayer/on/next/previous),
   dieselbe, die SlideshowElement/ProductComplementary in theme.js verwenden.
   Entfernbar: Datei löschen + Script-Zeile in layout/theme.liquid entfernen. */
(function () {
  'use strict';
  if (window.__flktyWheelSwipe) return;
  window.__flktyWheelSwipe = true;

  var SELECTOR = 'product-complementary.flickity, .horizontal-products.flickity, slideshow-element, carousel-element';
  var THRESHOLD = 24;         // px horizontaler Akkumulation bis zum Weiterblättern (Standard)
  var COOLDOWN = 220;         // ms Sperre zwischen zwei Wechseln (Standard)
  var GENTLE_THRESHOLD = 40;  // höhere Schwelle für Ein-Bild-Karussells (weniger empfindlich)
  var GENTLE_COOLDOWN = 320;  // ms Sperre nach einem Schritt (zeit-basiert -> direkt weiter-swipbar)

  function getFlkty(el) {
    if (el.slider && typeof el.slider.next === 'function') return el.slider;         // slideshow-element
    if (el.carousel) {
      if (typeof el.carousel.next === 'function') return el.carousel;               // carousel-element (Flickity direkt, z.B. Lookbook "Aus der gleichen Serie")
      if (el.carousel.slider) return el.carousel.slider;                            // product-complementary (theme.Carousel-Wrapper)
    }
    if (window.Flickity && Flickity.data) return Flickity.data(el) || null;         // Fallback (jedes Flickity)
    return null;
  }

  function enhance(el, tries) {
    tries = tries || 0;
    if (el.__wheelSwipe) return;
    var flk = getFlkty(el);
    // Flickity wird asynchron (inView / connectedCallback) initialisiert -> mit Retry warten
    if (!flk) { if (tries < 40) setTimeout(function () { enhance(el, tries + 1); }, 150); return; }
    el.__wheelSwipe = true;

    // Nur echte Autoplay-Slideshows nach Interaktion wieder anwerfen
    var wantsAutoplay = el.hasAttribute('autoplay');
    function resumeAutoplay() {
      if (!wantsAutoplay || typeof flk.playPlayer !== 'function') return;
      // kurzer Delay, damit Flickity die Interaktion abschließt, dann Autoplay neu starten
      setTimeout(function () { try { flk.playPlayer(); } catch (e) {} }, 60);
    }

    // Ein-Bild-Karussells (Lookbook "Aus der gleichen Serie") sind viel empfindlicher:
    // eine einzige Wisch-Geste soll GENAU EIN Bild weiterblättern, nicht mehrere.
    var gentle = el.matches('carousel-element');

    // 1) Wisch-/Wheel-Geste -> weiterblättern (und Autoplay am Leben halten)
    var acc = 0, cooling = false, gentleLockUntil = 0;
    el.addEventListener('wheel', function (e) {
      // nur horizontale Absicht: Magic Mouse / Trackpad quer -> deltaX; Shift+Rad -> deltaY
      var dx = Math.abs(e.deltaX) >= Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
      if (!dx) return;               // rein vertikales Scrollen NICHT kapern
      e.preventDefault();

      if (gentle) {
        // "1 Wisch = 1 Schritt": nach einem Schritt kurz ZEIT-BASIERT sperren und die
        // Trägheits-Nachlauf-Events schlucken. Zeit-basiert (nicht pausen-basiert!), damit
        // man DIREKT wieder swipen kann, ohne die Maus aus dem Feld zu bewegen.
        var now = Date.now();
        if (now < gentleLockUntil) { acc = 0; return; }   // gesperrt -> Trägheit ignorieren
        acc += dx;
        if (Math.abs(acc) > GENTLE_THRESHOLD) {
          if (acc > 0) { flk.next(); } else { flk.previous(); }
          acc = 0;
          gentleLockUntil = now + GENTLE_COOLDOWN;
          resumeAutoplay();
        }
        return;
      }

      // Standard (breitere/mehrkartige Karussells): unverändert
      acc += dx;
      if (cooling) return;
      if (Math.abs(acc) > THRESHOLD) {
        if (acc > 0) { flk.next(); } else { flk.previous(); }
        acc = 0;
        cooling = true;
        setTimeout(function () { cooling = false; }, COOLDOWN);
        resumeAutoplay();
      }
    }, { passive: false });

    // 2) Nach manuellem Drag/Klick Autoplay wieder starten (sonst bleibt er dauerhaft aus)
    if (wantsAutoplay && typeof flk.on === 'function') {
      flk.on('dragEnd', resumeAutoplay);
      flk.on('staticClick', resumeAutoplay);
    }
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) enhance(nodes[i]);
  }

  function start() {
    scan();

    // Ergänzende Produkte laden per AJAX nach -> Event 'recommendations:loaded' bubbelt
    // nicht, daher Capture-Phase-Listener am document.
    document.addEventListener('recommendations:loaded', function (e) {
      setTimeout(function () { scan(e.target); }, 80);
    }, true);

    // Robustes Binden: childList (neu eingefügte Karusselle) UND das Setzen der
    // 'flickity-enabled'-Klasse (Flickity-Init, z.B. wenn die Slideshow in den Viewport
    // scrollt) beobachten.
    if ('MutationObserver' in window && document.body) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.type === 'attributes') {
            var t = m.target;
            if (t.nodeType === 1 && t.matches && t.matches(SELECTOR)) enhance(t);
            continue;
          }
          var added = m.addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches(SELECTOR)) {
              (function (node) { setTimeout(function () { enhance(node); }, 80); })(n);
            } else if (n.querySelector && n.querySelector(SELECTOR)) {
              (function (node) { setTimeout(function () { scan(node); }, 80); })(n);
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
